import { useResponsive } from '@/hooks/use-responsive';
import { useTheme } from '@/contexts/ThemeContext';
import { FiSun, FiMoon } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { HeaderQrButton } from './HeaderQrButton';
import { NotificationBell } from './notifications/NotificationBell';
import './AppHeader.css';

interface AppHeaderProps {
  // onMenuPress is deprecated as navigation is now at the bottom
}

/**
 * Componente de header fijo y uniforme para todas las pantallas protegidas.
 * En móvil: tema (izq), BIAVENT (centro), Mi QR + campana (der). Sin QR en bottom nav.
 * En desktop/web: muestra solo el título centrado (la navegación superior está en otro lugar).
 */
export function AppHeader({}: AppHeaderProps) {
  const { isMobile } = useResponsive();
  const navigate = useNavigate();
  const { theme, setTheme, effectiveTheme } = useTheme();

  // Solo mostrar en móvil
  if (!isMobile) {
    return null;
  }

  const handleThemeToggle = () => {
    if (theme === 'auto') {
      setTheme('light');
    } else if (theme === 'light') {
      setTheme('dark');
    } else {
      setTheme('auto');
    }
  };

  const isDark = theme === 'auto' ? effectiveTheme === 'dark' : theme === 'dark';

  const getThemeLabel = () => {
    if (theme === 'auto') return `Auto (${effectiveTheme === 'dark' ? 'Oscuro' : 'Claro'})`;
    return theme === 'dark' ? 'Oscuro' : 'Claro';
  };

  return (
    <header className="app-header">
      <div className="app-header-content">
        <button 
          onClick={handleThemeToggle} 
          className="app-header-menu-button" 
          aria-label={`Cambiar tema. Actual: ${getThemeLabel()}`}
          title={`Tema: ${getThemeLabel()}`}
        >
          {isDark ? (
            <FiMoon size={18} color="#FBBF24" />
          ) : (
            <FiSun size={18} color="#FBBF24" />
          )}
        </button>
        <button onClick={() => navigate('/eventos')} className="app-header-logo">
          BIAVENT
        </button>
        <div className="app-header-actions">
          <HeaderQrButton variant="mobile" />
          <NotificationBell variant="mobile" />
        </div>
      </div>
    </header>
  );
}

/**
 * Calcula la altura total del header incluyendo SafeArea.
 */
export function useHeaderHeight(): number {
  // En móvil: --mobile-header-bar + safe area top
  // En desktop: 80px
  if (typeof window !== 'undefined' && window.innerWidth < 768) {
    const safeAreaTop = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--safe-area-inset-top') || '0px', 10) || 0;
    const headerBar = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--mobile-header-bar') || '56px', 10) || 56;
    return headerBar + safeAreaTop;
  }
  return 80;
}


